import favicon from "../assets/logo.jpg";
import logolight from "../assets/logo.jpg";
import logo from "../assets/logo.png";
import usericon from "../assets/usericon.png";
import bg from "../assets/bg1.jpg";

import treearrow from "../assets/treearrow.png";
const assetimages = {
  favicon,logolight, logo, usericon,
  bg, treearrow
}
export default assetimages;